import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useEffect } from 'react';
import { bootstrapSession, setUnauthorizedHandler } from './lib/api';
import { useAuthStore } from './lib/auth-store';
import { LoginPage } from './routes/login';
import { RecoveryPage } from './routes/recovery';
import { OverviewPage } from './routes/overview';
import { CallsPage } from './routes/calls';
import { CallDetailPage } from './routes/call-detail';
import { ReportsPage } from './routes/reports';
import { EmployeesPage } from './routes/employees';
import { KnowledgeBasePage } from './routes/knowledge-base';
import { CorrectionsPage } from './routes/corrections';
import { SettingsPage } from './routes/settings';
import { ForbiddenPage } from './routes/forbidden';
import { ComplaintsPage } from './routes/complaints';
import { AdminLayout } from './components/layout/admin-layout';
import { RequireAdmin } from './components/auth/require-admin';
import { RequireComplaintWorkbench } from './components/auth/require-complaint-workbench';
import { isAdminRole } from './lib/auth-store';

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const clear = useAuthStore((s) => s.clear);

  // Issue #401：启动期会话引导（幂等）——清理旧 localStorage 持久化会话，并凭
  // HttpOnly Cookie 静默续期恢复内存 accessToken；完成前路由守卫渲染「验证中」。
  useEffect(() => {
    void bootstrapSession();
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      clear();
      if (!location.pathname.startsWith('/login')) {
        navigate('/login', {
          replace: true,
          state: { from: location.pathname + location.search },
        });
      }
    });
  }, [clear, navigate, location.pathname, location.search]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Issue #21：超级管理员恢复码应急登录（公开路由，与 /login、/403 并列）。 */}
      <Route path="/recovery" element={<RecoveryPage />} />
      <Route path="/403" element={<ForbiddenPage />} />
      <Route
        element={
          <RequireComplaintWorkbench>
            <AdminLayout />
          </RequireComplaintWorkbench>
        }
      >
        <Route index element={<WorkbenchHomeRedirect />} />
        <Route path="/complaints" element={<ComplaintsPage />} />
        <Route
          element={
            <RequireAdmin>
              <Outlet />
            </RequireAdmin>
          }
        >
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/calls" element={<CallsPage />} />
          <Route path="/calls/:id" element={<CallDetailPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/corrections" element={<CorrectionsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<WorkbenchHomeRedirect />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function WorkbenchHomeRedirect() {
  const user = useAuthStore((state) => state.user);
  return <Navigate to={isAdminRole(user?.role) ? '/overview' : '/complaints'} replace />;
}
